// extracted by mini-css-extract-plugin
export default {"textField":"tumOJgmh","input":"mmZEfLhL","error":"J4wwMGHm","placeholderAnimate":"u1BJO_kg","placeholderAnimateShow":"MaoUkFQW"};